(function() { module.exports = this["NeoGames"]; }());


/*****************
 ** WEBPACK FOOTER
 ** external "NeoGames"
 ** module id = 21
 ** module chunks = 0
 **/